import Skeleton from 'components/Skeleton';
import useMobileView from 'hooks/useMobileView';
import { useMemo } from 'react';
import { useColorScheme } from 'redesignedComponents/context/colorScheme';
import useStyles from 'redesignedComponents/sections/BannerBlock/styles';
import { Height } from './enums';
import { BannerBlockProps } from './types';

const BannerBlockSkeleton = ({ height }: BannerBlockProps) => {
  const colorScheme = useColorScheme();
  const { isMobile } = useMobileView();
  const styles = useStyles({
    colorScheme,
    isMobile,
  });
  const isDefaultHeight = height === Height.DEFAULT;

  const sizing = useMemo(() => {
    return {
      minHeight:
        height && !isDefaultHeight
          ? Number(height.replace(/\D/g, ''))
          : Number(Height.H640.replace(/\D/g, '')),
    };
  }, [height, isDefaultHeight]);

  return (
    <div style={sizing} className={styles.skeletonRoot}>
      <div className={styles.skeletonContent}>
        <Skeleton />
      </div>
    </div>
  );
};

export default BannerBlockSkeleton;
